import React, { useState } from "react"

import OrderTable from "./UI/OneStepAllocationOrderTable"

const OneStepAllocationPreview = props => {
  const [totalAmount, setTotalAmount] = useState(0)

  return (
    <div>
      <h2 className="text-center">
        Your {props.order.releaseYear.year} {props.currentAllocationPeriod} Release
      </h2>

      <OrderTable
        additionalProducts={props.additionalProducts || []}
        productsPath={null}
        orderId={null}
        previewMode={true}
        {...props.order}
        setTotalAmount={setTotalAmount}
        selfPickUp={false}
        paid={true}
      />
    </div>
  )
}

export default OneStepAllocationPreview